import React from 'react'
import {
  Grid, Card, Image, Loader, Icon, Label, Button
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'

const byFree = (template) => {
  if (template.context.toLowerCase() === 'free' && template.title.toLowerCase() !== 'empty') {
    return true
  }
}

const TemplateButtons = ({ template }) => {
  return (
    <>
      <Link to={`/template/page/${template.id}`}>
        <Button
          primary
          className="buttonTwo"
        >
          Page Builder
      </Button>
      </Link>
      <Link to={`/template/email/${template.id}`}>
        <Button
          primary
          className="buttonOne"
        >
          Email Builder
      </Button>
      </Link>
    </>
  )
}

const ChooseTemplate = (props) => {
  const { data } = props

  return (
    (data && data.length > 0)
      ? (
        <Grid>
          {
            data
              .filter(byFree)
              .map(
                (template, i) => {
                  const { industries } = template
                  return (
                    <Grid.Column key={i} width={4}>
                      <Card fluid>
                        <div className="btnContainer" style={{ height: '250px', width: '100%' }}>
                          <Image
                            src={template.thumbnail}
                            style={{
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover',
                              objectPosition: '0 0'
                            }}
                            bordered
                          />
                          <TemplateButtons template={template} />
                        </div>
                        <Card.Content>
                          <Card.Header style={{
                            paddingBottom: '10px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '220px'
                          }}>{template.title}</Card.Header>
                          <Card.Meta>
                            {
                              industries && industries.slice(0, 1).map(
                                (industry, i) => {
                                  return (
                                    <Label key={i}>
                                      <Icon name='industry' /> {industry.name}
                                    </Label>
                                  )
                                })
                            }
                          </Card.Meta>
                        </Card.Content>
                      </Card>
                    </Grid.Column>
                  )
                }
              )
          }
        </Grid>
      )
      : (<Loader active inline='centered'>Loading</Loader>)
  )
}
export default ChooseTemplate
